import Utility from "./utility";
import store from "../store";
import { keyMapsGetter, keyMapsMutation } from "../helpers/storeKeys";

var xDown = null;
var yDown = null;

function getTouches(evt) {
  return evt.touches;
}

function handleTouchStart(evt) {
  const firstTouch = getTouches(evt)[0];
  xDown = firstTouch.clientX;
  yDown = firstTouch.clientY;
}

const getCategoryId = (elmId) => {
  return elmId.replace("category_items_id_", "element_catg_");
};

const checkIfElementHasChild = (elmId) => {
  let ele = document.getElementById(elmId);
  if (ele !== null) {
    let childElements = ele.querySelector(".cards-wrap");
    if (childElements) {
      return true;
    }
  }
  return false;
};

const findIndexofElement = (elements) => {
  let position = {
    leftElementId: "",
    currentElementId: "",
    rightElementId: "",
    leftElementIndex: -1,
    currentElementIndex: -1,
    rightElementIndex: -1,
  };
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].style.display !== "none") {
      position.leftElementId = i - 1 >= 0 ? elements[i - 1].id : "";
      position.leftElementIndex = i - 1;
      position.currentElementId = elements[i].id;
      position.currentElementIndex = i;
      position.rightElementId =
        i + 1 <= elements.length - 1 ? elements[i + 1].id : "";
      position.rightElementIndex = i + 1;
    }
  }
  return position;
};

const jumpToNextCategory = (elements, elmIndex) => {
    if(elmIndex >=0 && elmIndex < elements.length) {
        setProductCounterString(elements[elmIndex].id);
        Utility.scrollUptoTo(getCategoryId(elements[elmIndex].id));
    }
};

const setProductCounterString = (itemId) => {
    let productItems = store.getters[keyMapsGetter.GET_PRODUCT_ITEM_FOR_BOTTOMBAR];
    itemId = itemId?.replace('category_items_id_', '');
    for(const product in productItems) {
        if(Number(productItems?.[product]?.categoryId) === Number(itemId)) {
            store.commit(
                keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
                productItems?.[product]?.categoryName
            );
        }
    }
};

const setSelectedMenuCategory = (category = "", id = "") => {
  //next , pre only
  if (!category) return;
  store.commit(keyMapsMutation.UPDATE_SELECTED_MENU_CATEGORY, {
    category: category,
    id: id,
  });
};

function handleTouchMove(evt) {
  if (!xDown || !yDown) {
    return;
  }

  var xUp = evt.touches[0].clientX;
  var yUp = evt.touches[0].clientY;

  var xDiff = xDown - xUp;
  var yDiff = yDown - yUp;

  let elements = document.querySelectorAll('*[id^="category_items_id_"]');
  let position = findIndexofElement(elements);

  // Animation is removed
  if (Math.abs(xDiff) > Math.abs(yDiff)) {
    /*most significant*/
    if (xDiff > 10) {
      /* right swipe */
      // currentElement.classList.add("swipe-right");
      // if(checkIfElementHasChild(position.rightElementId)) {
      //     setProductCounterString(position.rightElementId);
      //     Utility.scrollUptoTo(getCategoryId(position.rightElementId));
      // }
      // else {
      //     jumpToNextCategory(elements, position.rightElementIndex+1);
      // }
      // currentElement.classList.remove("swipe-right");
      setSelectedMenuCategory("next");
    } else if (xDiff < -10) {
      /* left swipe */
      // currentElement.classList.add("swipe-left");
      // if(checkIfElementHasChild(position.leftElementId)) {
      //     setProductCounterString(position.leftElementId);
      //     Utility.scrollUptoTo(getCategoryId(position.leftElementId));
      // }
      // else {
      //     jumpToNextCategory(elements, position.leftElementIndex-1);
      // }
      // currentElement.classList.remove("swipe-left");
      setSelectedMenuCategory("pre");
    }
  } else {
    if (yDiff > 0) {
      /* down swipe */
    } else {
      /* up swipe */
    }
  }
  /* reset values */
  xDown = null;
  yDown = null;
}

export default {
  handleTouchStart,
  handleTouchMove,
};
